































// vue
import { defineComponent, ref } from '@vue/composition-api';

// prime-vue
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';

// models
import { GeoRecord } from '@/vue3/api/models';

// services
import { useService } from '@/vue3/api/services';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useNotify } from '@/vue3/hooks/notifyHook';

export default defineComponent({
    components: {
        Button,
        ProgressSpinner,
    },
    props: {
        clearGeoRecordSelection: {
            type: Function,
            default: () => {},
        },

        mapbox: {
            type: Object,
            default: () => {},
        },
        geoRecordsArray: {
            type: Array,
            default: () => [],
        },

        isModifyAllowed: {
            type: Boolean,
            default: false,
        },
        layerTree: {
            type: Object,
            default: null,
        },
        prepareGeoRecordFormData: {
            type: Function,
            default: () => {},
        },
        changeDrawMode: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // services
        const { createMultipleGeoRecords, deleteMultipleArchiveGeoRecord } =
            useService();

        // hooks
        const {
            addGeoRecord,
            initCreateGeoRecordSource,
            removeCreateGeoRecordSource,
            refreshGeoRecordExtrusion,
            updateGeoRecordExtrusion,
        } = useGeoRecord();

        const { successToast } = useNotify();

        // ref
        const isLoading = ref<boolean>(false);

        // mehthods
        const refreshGeorecordTree = async () => {
            await props.layerTree.refershArchiveGeoRecordLayerTree();

            await props.layerTree.fetchArchiveEvents();
            props.layerTree.refershArchiveGeoRecordLayer();
            removeCreateGeoRecordSource(props.mapbox.map);
        };

        const moveArchiveRecords = async (): Promise<void> => {
            isLoading.value = true;
            let newGeoRecords: any = [];
            const geoRecordIds = props.geoRecordsArray.map(
                (record: any) => record.id,
            );

            let formData = props.prepareGeoRecordFormData(
                props.geoRecordsArray,
                false,
                10,
            );

            try {
                if (formData) {
                    newGeoRecords = await createMultipleGeoRecords(formData);
                    await deleteMultipleArchiveGeoRecord(geoRecordIds);
                }
            } catch (error) {
                console.log(error)
                props.clearGeoRecordSelection();
            }

            if (newGeoRecords.length > 0) {
                newGeoRecords.forEach(async (newGeoRecord: GeoRecord) => {
                    addGeoRecord(props.mapbox.map, newGeoRecord);
                    initCreateGeoRecordSource(props.mapbox.map, newGeoRecord);
                    updateGeoRecordExtrusion(props.mapbox.map, newGeoRecord);
                    refreshGeoRecordExtrusion(props.mapbox.map, newGeoRecord);
                });
            
            await props.layerTree.refreshGeoRecordTreeAndState(
                geoRecordIds,
                true,
            );

                refreshGeorecordTree();

                successToast('Successfully moved archive geo records.');
            }

            props.clearGeoRecordSelection();
            props.changeDrawMode();

            isLoading.value = false;
        };

        return { moveArchiveRecords, isLoading };
    },
});
